import { first, isArray } from 'lodash'
import React from 'react'
import BarcodeScanner from 'react-qr-barcode-scanner'

type TNewScannerProps = {
  onScan: (code: string) => void
}

const NewScanner = (props: TNewScannerProps): React.ReactElement => {
  const { onScan } = props

  const onUpdate = (e, result): void => {
    if (result?.text) {
      let barcode = result?.text
      try {
        // ["2020612579100001581","ERNST DELLO GMBH & CO. KG","SENEFELDER-RING","2","21465","Reinbek","DE","26603","2020>NEN01"]
        const arr = JSON.parse(result?.text)
        if (isArray(arr)) {
          barcode = first(arr)
        }
      } catch (err) {}
      onScan(barcode)
    }
  }

  return (
    <div>
      <BarcodeScanner height={470} width={470} onUpdate={onUpdate} />
    </div>
  )
}

export default NewScanner
